import { useEffect, useState } from "react";
import { Card, Col, Descriptions, Form, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import { fetchCertificationsList } from "../../../../../store/CommonSlice";
import { fetchIndustryList, fetchIndustryWizeData } from "../../../Industry/utils/slice";
import { fetchCareercategory } from "../../../../../store/CommonSlice";

import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../utils/hooks/hooks";

import { IMAGE_UPLOAD, INDUSTRY_FILTER } from "../../../../../config/Constant";
import React from "react";
import { getGroupList } from "../../utils/slice";
import { renderNA } from "../../../../../utils/commonFunctions";

/**
 * Renders a form component for adding or editing a record in career module.
 *
 * @param {object} props - The component props.
 * @param {object} props.form - The form instance.
 * @param {string} props.id - The form ID.
 * @param {function} props.handleSubmit - The function to handle form submission.
 * @param {function} props.onValuesChange - The function to handle form value changes and update the form fields.
 * @param {object} props.editValues - The values to edit in the form fields, if value already exists.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const [fileList, setFileList] = useState<any>([]);
  const [videoUrl, setVideoUrl] = useState<boolean>(false);
  const [fileListUrl, setFileListUrl] = useState<boolean>(false);
  const [industryList, setIndustryList] = useState<any>([]);
  const [groupList, setGroupList] = useState<any>([]);
  const [carierCategoryList, setCarierCategoryList] = useState<any>([]);
  const [certificationsList, setCertificationsList] = useState<any>([]);
  const [categoryDescriptionArray, setCategoryDescriptionArray] = useState<any>([]);
  const categoriesWatch = Form.useWatch('categories', form);

  useEffect(() => {
    if (editValues?.file) {
      setFileList([
        {
          uid: "-1",
          status: "done",
          url: IMAGE_UPLOAD + editValues?.file,
        },
      ]);
    }

    dispatch(fetchIndustryList())
      .then((data: any) => {
        setIndustryList(data.rows);
      })
      .catch((error: any) => error);

    dispatch(getGroupList())
      .then((data: any) => {
        // console.log(data)
        setGroupList(data.data.data);
      })
      .catch((error: any) => error);


  }, [editValues?.file]);

  useEffect(() => {
    if (editValues) {
      console.log(editValues)
      if (!editValues?.file && editValues?.video_url) {
        setVideoUrl(true);
      } else {
        setVideoUrl(false);
      }
    }
    if (!editValues?.video_url && editValues?.file) {
      setFileListUrl(true);
    } else {
      setFileListUrl(false);
    }
    onIndustryChange(editValues?.industries.map((data: any) => data.id), false);

    const {
      default_flag,
      critical
    } = editValues ?? {};
    form.setFieldsValue({
      name: editValues?.name,
      certifications: editValues?.certifications.map((data: any) => data.id),
      description: editValues?.description,
      video_url: editValues?.video_url,
      file: editValues?.file ? editValues.file : null,
      knowledge_skills: editValues?.knowledge_skills,
      education_training: editValues?.education_training,
      experience: editValues?.experience,
      credentialing: editValues?.credentialing,
      // career_category_text: editValues?.career_category_text,
      // position_reports_to: editValues?.position_reports_to,
      career_path_moves_from_this_role:
        editValues?.career_path_moves_from_this_role,
      salary_start: editValues?.salary_start,
      salary_end: editValues?.salary_end,
      default_flag: [
        default_flag,
      ],
      critical: [
        critical ? 1 : 0,
      ],
      industries: editValues?.industries.map((data: any) => data.id),
      categories: editValues?.categories.map((data: any) => data.id),
      group_id: editValues?.group_id,
      level: editValues?.level,
    });




  }, [editValues]);



  useEffect(() => {
    if (editValues && carierCategoryList.length > 0) {
      setChangeDesc(editValues?.categories.map((data: any) => data.id))
    }
  }, [carierCategoryList])


  useEffect(() => {
    if (categoriesWatch && categoriesWatch.length > 0) {
      setChangeDesc(categoriesWatch)
    }
  }, [categoriesWatch])






  /**
   * Process the form data and handle the form submission.
   *
   * @param {any} data - The form data to be processed.
   * @return {Promise<void>} A promise that resolves when the form submission is complete.
   */
  const onFinish = async (data: any) => {

    data.default_flag = data?.default_flag != undefined && data.default_flag?.length > 0 && data.default_flag[0] != undefined ? data.default_flag[0] : 0;
    data.critical = data?.critical != undefined && data.critical?.length > 0 && data.critical[0] != undefined ? data.critical[0] : 0;

    if (data.description !== String(data.description)) {
      data.description = data?.description?.level?.content;
    }
    if (
      data.career_path_moves_from_this_role !==
      String(data.career_path_moves_from_this_role)
    ) {
      data.career_path_moves_from_this_role =
        data?.career_path_moves_from_this_role?.level?.content;
    }
    // if (data.position_reports_to !== String(data.position_reports_to)) {
    //   data.position_reports_to = data?.position_reports_to?.level?.content;
    // }
    if (data.education_training !== String(data.education_training)) {
      data.education_training = data?.education_training?.level?.content;
    }
    if (data.experience !== String(data.experience)) {
      data.experience = data?.experience?.level?.content;
    }
    if (data.credentialing !== String(data.credentialing)) {
      data.credentialing = data?.credentialing?.level?.content;
    }
    if (data.knowledge_skills !== String(data.knowledge_skills)) {
      data.knowledge_skills = data?.knowledge_skills?.level?.content;
    }
    // if (data.career_category_text !== String(data.career_category_text)) {
    //   data.career_category_text = data?.career_category_text?.level?.content;
    // }
    handleSubmit(data);
  };



  const onIndustryChange = (id: any, resetVal = true) => {
    if (id && id.length > 0) {

      if (resetVal) {
        form.setFieldsValue({
          categories: [],
          certifications: [],

        });
      }
      dispatch(fetchIndustryWizeData(id, [
        INDUSTRY_FILTER.CAREER_CATEGORY,
        INDUSTRY_FILTER.CERTIFICATION
      ]))
        .then((response: any) => {

          setCarierCategoryList(response.data.career_category)
          let certificationCustom = [];
          if (response.data.certification && response.data.certification.length > 0) {
            certificationCustom = response.data.certification.map((item: any) => {
              return {
                id: item.id,
                name: `${item.acronym} - ${item.short_form} - (${item.industries.map((ind: any) => ind.industry_name).join()})`
              }
            })
          }
          setCertificationsList(certificationCustom)
        })
        .catch((error: any) => error);
    }
    else {
      if (resetVal) {
        form.setFieldsValue({
          categories: [],
          certifications: [],

        });
        setCertificationsList([])
      }
    }

  }


  /**
 * Handles the change event for Image  upload.
 *
 * @param {any} data - The data object containing the file status and fileList.
 * @return {void} This function does not return anything.
 */
  const onChange = (data: any) => {
    if (data.file?.status === "error" || data.file?.status === "uploading") {
      setFileList([]);
    } else {
      setFileList(data.fileList);
    }

    // Disable and Enable the video url field based on the selected file
    const getFileList = form.getFieldValue("file")?.uid?.length > 0;
    getFileList ? setFileListUrl(true) : setFileListUrl(false);
  };

  /**
 * Disable and Enable the Image upload field based on the value of the "video_url" field in the form.
 *
 * @return {void} This function does not return anything.
 */
  const changeVideoUrl = () => {
    const getVideoUrl = form.getFieldValue("video_url")?.length > 0;
    getVideoUrl ? setVideoUrl(true) : setVideoUrl(false);
  };



  const setChangeDesc = (data: any) => {
    // console.log('selectedCategory data', data, carierCategoryList)

    if (data && data.length > 0) {
      let selectedCategory = carierCategoryList.filter((item: any) => {
        if (data.includes(item.id)) {
          return item.id;
        }
      })
      // console.log('selectedCategory', selectedCategory)
      setCategoryDescriptionArray(selectedCategory);
    }
    else {
      setCategoryDescriptionArray([]);
    }
  }
  const stripHtml = (html: string) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };





  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        {...rest}
      >
        <Row gutter={[15, 15]}>

          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="name"
              label="Name"
              rules={rules.name()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              mode="multiple"
              required
              label="Industries"
              name="industries"
              showSearch
              className="multiSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(val) => onIndustryChange(val)}

              options={{
                list: industryList,
                valueKey: "id",
                textKey: "industry_name",
              }}
            />

          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              name="certifications"
              label="Certifications"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={{
                list: certificationsList,
                valueKey: "id",
                textKey: "name",
              }}
              mode="multiple"
            />

          </Col>


          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              mode="multiple"
              required
              label="Career Category"
              name="categories"
              showSearch
              className="multiSelect"
              optionFilterProp="children"
              // tooltip={'Only filter purpose for all career pages'}
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: carierCategoryList.map((item: any) => {
                  const obj = { ...item };
                  obj.name = `${item.code} - ${item.name}`;
                  return obj;
                }),
                valueKey: "id",
                textKey: "name",
              }}

            />
          </Col>
          {categoryDescriptionArray.length > 0 &&
            <Col xs={{ span: 24 }} md={{ span: 24 }}>
              <Descriptions title={''} styles={{ label: { width: '50%' }, root: { height: '30rem', overflowY: 'auto' } }} column={1} bordered layout="vertical">
                {categoryDescriptionArray.map((item: any) => {
                  return <>
                    <Descriptions.Item key={item.code} label={<>{renderNA(item.code)} - {renderNA(item.name)}</>}>
                      <div style={{ maxHeight: '25rem', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: item.description }}></div>
                    </Descriptions.Item>
                  </>

                })}
              </Descriptions>

            </Col>}


          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Checkbox
              style={{ margin: 0 }}
              name="default_flag"
              options={{
                list: [
                  {
                    id: 1,
                    name: "Default Status",
                  },
                ],
              }}

            />
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Checkbox
              style={{ margin: 0 }}
              name="critical"
              options={{
                list: [
                  {
                    id: 1,
                    name: "Critical Status",
                  },
                ],
              }}

            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              label="Career Group"
              name="group_id"
              showSearch
              allowClear
              className="singleSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: groupList,
                valueKey: "id",
                textKey: "name",
                // disabled:true
              }}
            />

          </Col>

          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Number
              maxLength={4}
              name="level"
              rules={rules.level()}
              minValue={1}
              min={1}
              max={9999}
              maxValue={9999}
              label="Career Level"
            />

          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.CareersImageUpload
              name="file"
              imageUrl={editValues?.file}
              label="Image"
              onChange={onChange}
              fileList={fileList}
              disabled={videoUrl}
              tooltip={"Please select either Image or Youtube Video URL."}
            />
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              name="video_url"
              label="Youtube Video URL"
              disabled={fileListUrl}
              tooltip={"Please select either Image or Youtube Video URL."}
              onChange={() => changeVideoUrl()}
            />
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Text
              name="salary_start"
              label="Salary Start"
              required
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Text
              name="salary_end"
              label="Salary End"
              required
            />
          </Col>

        </Row>


        <Row gutter={[15, 15]}>



          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="description"
              label="Description"
              initValue={form.getFieldValue("description")}
              editorChange={(e: any) => {
                form.setFieldsValue({ description: e });
                onValuesChange();
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="knowledge_skills"
              label="Knowledge Skills"
              initValue={form.getFieldValue("knowledge_skills")}
              editorChange={(e: any) => {
                form.setFieldsValue({ knowledge_skills: e });
                onValuesChange();
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="education_training"
              label="Education Training"
              initValue={form.getFieldValue("education_training")}
              editorChange={(e: any) => {
                form.setFieldsValue({ education_training: e });
                onValuesChange();
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="experience"
              label="Experience"
              initValue={form.getFieldValue("experience")}
              editorChange={(e: any) => {
                form.setFieldsValue({ experience: e });
                onValuesChange();
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="credentialing"
              label="Credentialing Required Optional"
              initValue={form.getFieldValue("credentialing")}
              editorChange={(e: any) => {
                form.setFieldsValue({ credentialing: e });
                onValuesChange();
              }}
            />
          </Col>
          {/* <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="position_reports_to"
              label="Salary Range"
              initValue={form.getFieldValue("position_reports_to")}
              editorChange={(e: any) => {
                form.setFieldsValue({ position_reports_to: e });
                onValuesChange();
              }}
            />
          </Col> */}
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="career_path_moves_from_this_role"
              label="Career Path Moves From This Role"
              initValue={form.getFieldValue("career_path_moves_from_this_role")}
              editorChange={(e: any) => {
                form.setFieldsValue({ career_path_moves_from_this_role: e });
                onValuesChange();
              }}
            />
          </Col>

          {/* <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="career_category_text"
              label="Career Category Description"
              initValue={form.getFieldValue("career_category_text")}
              editorChange={(e: any) => {
                form.setFieldsValue({ career_category_text: e });
                onValuesChange();
              }}
            />
          </Col> */}
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
